module.exports = __webpack_public_path__ + "30a95da5371cf64e60fd1fe25d71cccb.pdf";